import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, updateCartQuantity } from '../redux/cartSlice';
import { useNavigate } from 'react-router-dom';

const Product = ({ product }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Get the product from the cart to know if it's already in the cart
  const cartItem = useSelector((state) =>
    state.cart.cart.find((item) => item.id === product.id)
  );

  // Use the cart item's quantity if it exists, otherwise set to 1
  const initialQuantity = cartItem ? cartItem.quantity : 1;

  const [quantity, setQuantity] = useState(initialQuantity);
  
  // Handle quantity change (increase or decrease)
  const handleQuantityChange = (operation) => {
    setQuantity((prevQuantity) => {
      if (operation === 'increase' && prevQuantity < 10) {
        return prevQuantity + 1; // Increase quantity
      } else if (operation === 'decrease' && prevQuantity > 1) {
        return prevQuantity - 1; // Decrease quantity, but prevent going below 1
      }
      return prevQuantity;
    });
  };

  const handleAddToCart = () => {
    // Check if the product is already in the cart
    const item = {
      id: product.id,
      name: product.name,
      price: product.price,
      quantity: quantity, // Use the quantity selected by the user
      code: product.product_code
    };

    if (cartItem) {
      // If product is already in the cart, update its quantity
      dispatch(updateCartQuantity(item));
    } else {
      // If product is not in the cart, add it
      dispatch(addToCart(item));
    }
  };

  const openDescription = (code) => {
    navigate(`/products/${code}`)
  }

  return (
    <div className='col-md-6 col-sm-6 col-lg-4 col-12 mb-5'>
      <div className='boxes'>
        <img src={product.thumbnail} alt={product.name} onClick={() => openDescription(product.product_code)} className='img-fluid productThumbnail'/>
        <h3 title={product.name}>
          {product.name.substr(0, 20)}{product.name.length > 19 ? '...' : ''}
        </h3>
        <p>₹<b>{product.price.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/-</b></p>
        
        <div className='mt-3 d-flex justify-content-center position-relative'>
          <i class="fa fa-heart mr-1 heartIcon"></i>
          <button
            className="button-53"
            onClick={() => openDescription(product.product_code)}
            role="button"
          >
            View Product
          </button>
        </div>
      </div>
    </div>
  );
};

export default Product;
